export default __webpack_public_path__ + "static/media/DwapeJohnson.16604e11.jpg";